import {Tooltip} from "bootstrap";

/**
 * Enable tooltips in the current DOM
 * @returns {Promise<void>}
 */
export function useTooltips() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList?.map(function (el) {
        return new Tooltip(el);
    });
}

/**
 * Format a price for display purposes with 2 fractions digits comma (ex. 10,50).
 * @param price
 * @param reduction
 * @returns {string} returns an empty string if price is undefined.
 */
export function formatPrice(price, reduction = false) {
    if (price) {
        const parsedPrice = parseFloat(price);
        let formattedPrice = parsedPrice.toFixed(2).replace('.', ',');

        if (parsedPrice && (parsedPrice < 0 || reduction))
            formattedPrice = '-' + formattedPrice;

        return formattedPrice;
    } else return '';
}

/**
 * Smooth scroll to a page area.
 * @param area the fired event
 */
export function goToPageArea(area) {
    if (area) area.scrollIntoView({behavior: 'smooth'});
}
